import { createContext, useContext } from 'react'
import { type ClickToTextViewStore } from 'pages/clickToText/store'

export const ClickToTextViewContext = createContext<ClickToTextViewStore | null>(null)

export function useClickToTextViewContext() {
  const context = useContext(ClickToTextViewContext)
  if (context === null) {
    throw new Error('You have forgotten to wrap your root component with ClickToTextViewContext')
  }
  return context
}
